import store from '@/store'

export default class Chatwoot {
	static async init() {
		const user = await store.dispatch('refreshCurrentUser')

		// No user, skip
		if (user === null) return

		// If the user is staff, admin or third party, skip
		if (user.isAdmin || user.isStaff || user.isThirdParty) return

		// Load chatwoot widget
		window.chatwootSettings = {
			position: 'right',
			type: 'expanded_bubble',
			launcherTitle: 'Need help?',
			locale: user.preferredLanguage,
		}
		;(function(d, t) {
			var BASE_URL = 'https://app.chatwoot.com'
			var g = d.createElement(t),
				s = d.getElementsByTagName(t)[0]
			g.src = BASE_URL + '/packs/js/sdk.js'
			g.defer = true
			g.async = true
			s.parentNode.insertBefore(g, s)
			g.onload = function() {
				window.chatwootSDK.run({
					websiteToken: 'cbmcrfzUX6CLK8gYfdgfcr9s',
					baseUrl: BASE_URL,
				})
			}
		})(document, 'script')

		// Chatwoot ready handler
		var chatwootReady = function(user) {
			return function() {
				// Set our user's information for the Chatwoot session
				window.$chatwoot.setUser(user.id, {
					email: user.email,
					name: user.fullName,
					phone_number: user.phoneNumber,
					company_name: user.organizationRef.name,
				})
			}
		}

		window.addEventListener('chatwoot:ready', chatwootReady(user))
	}

	static reset() {
		if (window.$chatwoot) window.$chatwoot.reset()
	}
}
